import C2cOrderPaymentServiceV1 from './c2cOrderPaymentServiceV1';

export default C2cOrderPaymentServiceV1;
